/********************************************************************
 * Some of our main.jsx files fo not include our design system styles.
 * importing our styles at the top of these main.jsx file might creat
 * CSS breaks since some pages are using only bootstrap. To get
 * around this problem simply wrap the highest order component
 * that needs the styles in this fragment 🐺
 * *****************************************
 * @format */

import React from 'react';

import '@/components/sttark_design_system/index.scss';

export const ApplyDesignSystemStyles = ({children}) => <React.Fragment>{children}</React.Fragment>;
